<!--
 - Author : wanghongling.
 - Date   : 2019/5/26.
 - File   : head.通用头部组件
 -->

<template>
  <div class="head-wrap">
    <div class="head-wrap-content">
      <div class="head-wrap-content-left">
        <ul class="menu">
          <li
              :class="[$route.name===item.name?'on':'']"
              v-for="(item, index) in menu"
              :key="index" @click="toMenu(item, index)">
            {{ item.meta.title }}
          </li>
        </ul>
        <span>{{ date }}</span>
        <span>{{ week }}</span>
        <span>{{ time }}</span>
      </div>
      <div class="head-wrap-content-right">
        <span>
          <b class="head-pic">
            <img :src="avatar?imgUrl+avatar:defaultAvatar" alt="">
          </b>{{ userName }}
        </span>
        <span class="span" @click="toBg" v-if="isWeb"><i class="iconfont icon-xiaoxi"></i>后台</span>
        <span class="span" @click="isExit"><i class="iconfont icon-tuichu"></i>【退出】</span>
      </div>
      <ul class="right-menu" :style="{right: $route.path==='/nStatistics'?'440px':'330px'}">
        <li :class="[$route.name===item.name?'on':'']"
            v-for="(item, index) in menuRight"
            :key="index" @click="toMenu(item, index)">{{ item.meta.title }}
        </li>
      </ul>
    </div>
    <div class="head-wrap-mask">
      <!--图片分辨率：765*80-->
      <img :src="sysScreenLogo" v-if="sysScreenLogo"/>
      <img src="../assets/images/head/defaultHead.png" v-else/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import RSA from '@/utils/RSA'
import {getToken} from '@/utils/auth'

export default {
  name: 'my-header',
  data() {
    return {
      currentdate: '',
      date: '',
      week: '',
      time: '',
      imgUrl: this.$store.getters.fileApi,
      // avatar: this.$store.getters.userInfo.avatar,
      defaultAvatar: require('../assets/images/avatar.jpg'),
      menu: [],
      menuRight: [],
      nowIndex: 0,
      isWeb: JSON.parse(window.localStorage.getItem('isWeb')),
      orgId: '',
      sysScreenLogo: '',
      orgData: {}
    }
  },
  computed: {
    ...mapGetters({  //这里的...不是省略号了,是对象扩展符
      userName: 'fullName',
      avatar: 'avatar',
      otherClientId: 'otherClientId',
      otherClientSecret: 'otherClientSecret',
      routes: 'routes'
    }),
    /**
     * 计算显示当前menu选中标签
     * @author: whl
     * @createDate: 2019/6/4
     */
    finalIndex() {
      let index
      switch (this.$route.path) {
        case '/':
          index = 0
          break
        case '/statistics':
        case '/nStatistics':
          index = 1
          break
        default:
          index = -1
          break
      }
      return index
    }
  },
  watch: {
    routes: {
      handler(allRoutes) {
        const menuRoutes = allRoutes.filter(val => val.display)
        console.log('menuRoutes:', menuRoutes)
        this.menu = menuRoutes.slice(0, 2)
        if (menuRoutes.length > 2) this.menuRight = menuRoutes.slice(2, 4)
        console.log('this.menu', this.menu, this.menuRight)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.getOrgInfo()
    // this.getAvatar()
    this.getWebMenu()
    this.getNowFormatDate()
    this.$nextTick(function () {
      setInterval(this.getNowFormatDate, 1000)
    })
    console.log('this.$router.options.routes', this.addRoutes)
  },
  methods: {
    /**
     * 获取组织信息
     * @author: wuzp
     * @param item
     * @param index
     * @createDate: 2022/01/18
     */
    getOrgInfo(){
      this.$request.accountLoginGet().then(res=>{
        console.log('head account login',res)
        window.localStorage.setItem('orgId' , res.orgId)
        this.$request.organizationDetailGet({'orgId':res.orgId})
            .then(res => {
              this.orgData = res
              console.log('orgData information', this.orgData)
              if(this.orgData.sysPlatformNameLogo) {
                this.sysScreenLogo = this.imgUrl + this.orgData.sysPlatformNameLogo
              }
            })
            .catch(e => {
              console.error(e)
            })
      }).catch(e=>{
        console.log(e)
      })
    },
    /**
     * menu跳转
     * @author: whl
     * @param item
     * @param index
     * @createDate: 2019/6/4
     */
    toMenu(item, index) {
      console.log('点击了***')
      this.nowIndex = index
      // this.$router.push(item.path)
      // console.log(item)
      this.$router.push({name: item.name})
    },
    /**
     * 获取当前日期和时间
     * @author: whl
     * @createDate: 2019/6/4
     * @return {Object}
     */
    getNowFormatDate() {
      // 获取当前日期
      let dateTime = new Date()
      // 定义星期
      let weekArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      let week = weekArr[dateTime.getDay()]

      // 年:判断小于10，前面补0
      let year = dateTime.getFullYear()
      // 月:判断小于10，前面补0
      let month = dateTime.getMonth() + 1
      month = month < 10 ? ('0' + month) : month
      // 日:判断小于10，前面补0
      let day = dateTime.getDate()
      day = day < 10 ? ('0' + day) : day
      // 时：判断小于10，前面补0
      let hours = dateTime.getHours()
      hours = hours < 10 ? ('0' + hours) : hours
      // 分:判断小于10，前面补0
      let minutes = dateTime.getMinutes()
      minutes = minutes < 10 ? ('0' + minutes) : minutes
      // 秒：判断小于10，前面补0
      let seconds = dateTime.getSeconds()
      seconds = seconds < 10 ? ('0' + seconds) : seconds

      // 拼接年月日时分秒
      this.currentdate = `${year}年${month}月${day}日 ${week} ${hours}：${minutes}：${seconds}`
      this.date = `${year}年${month}月${day}日`
      this.week = week
      this.time = `${hours}:${minutes}:${seconds}`
    },
    /**
     * 点击退出按钮
     * @author: whl
     * @createDate: 2019/6/4
     * @return {Object}
     */
    isExit() {
      this.$confirm('是否退出?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // window.getCefQuery(`closeH5`)
        this.$store.dispatch('user/logout').then(() => {
          window.localStorage.setItem('selfToken', '')
          let path = '/login'
          if(this.orgData.sysPlatformName){
            path = path+'?platformName='+this.orgData.sysPlatformName
          }
          this.$router.push({path: path})
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消退出！'
        // })
      })
    },
    /**
     * 获取用户头像
     * @author: whl
     * @createDate: 2019/6/4
     * @return {Object}
     */
    getAvatar() {
      let params = {
        sysId: window.localStorage.getItem('sysId'),
        userId: window.localStorage.getItem('userId')
      }
      this.$request.osysMemberInfoGet(params).then(res => {
        if (res.avatar) {
          this.avatar = window.localStorage.getItem('imgUrl') + res.avatar
        }
        console.log('用户头像', res)
      })
    },
    /**
     * @Description:
     * @author zhangkang
     * @date 2021/1/6
     */
    toBg() {
      if (window.localStorage.getItem('isWeb')) {
        this.getSite()
      }
    },
    /**
     * @Description:  获取应用地址
     * @author zhangkang
     * @date 2021/1/4
     */
    getSite() {
      let params = {
        clientId: this.otherClientId
      }
      this.$request.oauthApplicationTokenGet(params).then(res => {
        console.log(res, 'getWebSite')
        if (!this.$utils.isEmptyObject(res)) {
          window.location.href = res.entranceAddress + '?token=' + getToken()
          //this.dbLogin(res.entranceAddress)
        }
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * @Description: 二次登陆，后端
     * @author zhangkang
     * @date 2021/1/6
     */
    dbLogin(site) {
      if (window.localStorage.getItem('selfToken')) {
        window.location.href = site + '?token=' + window.localStorage.getItem('selfToken') + '&selfToken=' + getToken()
      } else {
        let info = JSON.parse(window.localStorage.getItem('loginInfo'))
        let params = {
          grant_type: 'password',
          scope: 'server',
          client_id: this.otherClientId,
          username: info.userName,
          password: RSA(info.password),
          client_secret: RSA(this.otherClientSecret)
        }
        this.$request.login(params).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            let url = site + '?token=' + res.access_token + '&selfToken=' + getToken()
            console.log(url, 'rrrrrrrrrrrrrrrrrrrrrrrrr')
            window.location.href = url
          }
        }).catch(e => {
          console.error(e)
        })
      }
    },
    /**
     * @Description: 获取大屏权限
     * @author zhangkang
     * @date 2021/1/4
     */
    getWebMenu() {
      let params = {
        clientId: this.otherClientId,
        platform: '01'
      }
      this.$request.menuTopListGet(params).then(params).then(res => {
        console.log(res, 'getWebMenu')
        if (!this.$utils.isEmptyObject(res)) {
          this.isWeb = res.length > 0
        }
        window.localStorage.setItem('isWeb', JSON.stringify(this.isWeb))
      }).catch(e => {
        console.error(e)
      })
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
.head-wrap {
  position: absolute;
  /*left: 50%;*/
  top: 0;
  /*margin-left: -960px;*/
  max-width: 1920px;
  width: 100%;
  height: 86px;
  display: flex;
  /*background: url("../assets/images/head/top1.png") no-repeat top center;*/
  align-items: flex-end;
  justify-content: space-between;
  /*padding: 0 55px 15px;*/
  /*z-index: 200;*/

  .head-wrap-mask {
    width: 40%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    //background: url("../assets/images/head/top2.png") no-repeat top center;
    z-index: 500;
    img{
      width: 100%;
      height: 100%;
    }
  }

  .head-wrap-content {
    width: 100%;
    height: 86px;
    box-sizing: border-box;
    padding: 0 8px 15px 55px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    background: url("../assets/images/head/top-top.png") no-repeat center center;
    z-index: 100;

    &-left {
      font-size: 15px;
      color: #00ffd2;
      margin-bottom: -10px;
      display: flex;
      align-items: center;
    }

    &-right {
      font-size: 13px;
      color: #00ffd2;
      margin-bottom: -12px;
    }

    span {
      padding-right: 10px;
      padding-left: 0;

      i {
        color: #009bbc;
        padding-right: 5px;
        font-size: 20px;
        vertical-align: sub;
      }

      .head-pic {
        width: 35px;
        height: 35px;
        display: inline-block;
        margin-right: 5px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid #0b80cc;
          vertical-align: middle;
          margin-top: -1px;
        }
      }
    }

    .span {
      cursor: pointer;
    }

    .span:hover {
      color: #fff;
      transition: color .5s;
    }

    .menu {
      display: flex;
      margin-left: -20px;
      margin-right: 40px;
      /*z-index: 600;*/

      li::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        background: #034c84;
        transform: skewX(20deg);
      }

      li {
        cursor: pointer;
        padding: 6px 20px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        text-decoration: none;
        margin-right: 5px;
        min-width: 80px;
      }

      li.on::before {
        background-color: #0a80b4;
        transform: skewX(20deg);
      }
    }

    .right-menu {
      display: flex;
      position: absolute;
      z-index: 600;
      top: 50px;
      right: 330px;

      li::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -1;
        background: #034c84;
        transform: skewX(-20deg);
      }

      li {
        cursor: pointer;
        padding: 6px 20px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        text-decoration: none;
        margin-right: 5px;
        min-width: 80px;
      }

      li.on::before {
        background-color: #0a80b4;
        transform: skewX(-20deg);
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/head.vue